import React from "react";

import classNames from "classnames";
import { Table } from "react-bootstrap";

import { UmpireProps } from "../types/umpire";

const BannedTeams = ({ umpire }: UmpireProps): React.JSX.Element => {
    return (
        <Table className={classNames("umpireData")}>
            <tbody>
                <tr>
                    <th scope="row" colSpan={2}>
                        <b>Banned Teams</b>
                    </th>
                </tr>
                <tr>
                    <th scope="row">Total Banned Teams</th>
                    <td>{umpire.currentYear?.bannedTeams?.length}</td>
                </tr>
                <tr>
                    <th scope="row">Banned Teams</th>
                    <td>{umpire.currentYear?.bannedTeams?.join(", ")}</td>
                </tr>
            </tbody>
        </Table>
    );
};

export default BannedTeams;
